import { CheckboxTheme } from '@kite-js/theme-types';
import colors from '@theme/priceline/theme-priceline/colors';

const Checkbox: CheckboxTheme = {
    labelSpacing: 'S',
};

export default Checkbox;
